import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {SysDataModelFieldService} from "../../../services/system/sys-data-model-field.service";
import {SysUiDisplayService} from "../../../services/system/sys-ui-display.service";
import {TagService} from "../../../services/tag/tag.service";
import {NzModalService} from "ng-zorro-antd/modal";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import * as _ from 'lodash';
import {NzNotificationService} from "ng-zorro-antd/notification";
import {StorageService} from "../../../services/storage.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'pi-search-condition-builder',
  templateUrl: './search-condition-builder.component.html',
  styleUrls: ['./search-condition-builder.component.css']
})
export class SearchConditionBuilderComponent implements OnInit, OnChanges {
  @ViewChild('modalContent') modalContent;
  @Input() dataModelId: any;
  @Input() pageName = 'default';
  @Input() pageCode = 'default';
  modelFields: any[] = [];
  searchConditions: any[] = [];
  detailForm: FormGroup;
  detailItem: any;
  modelFieldMap: any = {};
  searchSettings;
  businessType;
  mode: 'field' | 'tag' = 'field';

  constructor(
    private sysDataModelFieldService: SysDataModelFieldService,
    private sysUiDisplayService: SysUiDisplayService,
    private tagService: TagService,
    private modalService: NzModalService,
    private storageService: StorageService,
    private notification: NzNotificationService,
    private translateService: TranslateService,
    private fb: FormBuilder
  ) {
    this.businessType = this.storageService.getBusinessTypeItem();
  }

  ngOnInit(): void {
  }

  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.searchConditions, event.previousIndex, event.currentIndex);
    this.saveConfig();
  }

  async loadData() {
    this.businessType = this.storageService.getBusinessTypeItem();
    const dataColumnConfigs = await this.sysUiDisplayService
      .getConfigData(this.businessType, this.dataModelId, 'filter', this.pageName, this.pageCode).toPromise();
    if (dataColumnConfigs && dataColumnConfigs.length > 0) {
      this.searchSettings = dataColumnConfigs[0];
      this.searchConditions = JSON.parse(this.searchSettings.configContent);
    } else {
      this.searchSettings = null;
      this.searchConditions = [];
    }
  }

  buildForm() {
    this.detailForm = this.fb.group({
      mode: [this.mode, [Validators.required]],
      modelFieldId: this.mode === 'field' ? [null, [Validators.required]] : [null],
      targetTagDisplayName: this.mode === 'field' ? [null] : [null, [Validators.required]],
      targetTagFieldName: this.mode === 'field' ? [null] : ['tagIds', [Validators.required]],
      targetTagTypeCode: this.mode === 'field' ? [null] : [null, [Validators.required]],
      componentType: this.mode === 'field' ? [null, [Validators.required]] : ['tag'],
      selectDataType: ['manual'],
      logicExpress: [null],
      defaultSelectValue: [null],
      selectMode: ['default'],
      defaultSelectApi: [null],
      apiParams: ['{}}'],
      displayName: [null],
      selectLabel: [null],
      selectValue: [null],
      defaultValue: [null],
      switchOn: [true]
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.dataModelId) {
      this.modelFields = await this.sysDataModelFieldService.getById(this.dataModelId).toPromise();
      this.modelFields.forEach(m => {
        this.modelFieldMap[m.id] = m;
      })
      this.loadData();
    }

  }

  add(type: 'field' | 'tag') {
    this.mode = type;
    this.buildForm();
    const item = this.detailForm.getRawValue();
    item['uid'] = new Date().getTime();
    this.showModal(item);
  }

  async modify(item) {
    if (!item['mode']) {
      item['mode'] = 'field';
    }
    this.mode = item['mode'] ? item['mode'] : 'field';
    this.buildForm();
    this.showModal(item);
  }

  async duplicate(item) {
    this.searchConditions.push(item)
    await this.saveConfig();
    this.loadData();
  }

  async remove(index) {
    this.searchConditions.splice(index, 1);
    await this.saveConfig();
    this.loadData();
  }

  async saveConfig() {
    if (this.searchSettings) {
      this.searchSettings.configContent = JSON.stringify(this.searchConditions)
    } else {
      this.searchSettings = {
        businessType: this.businessType,
        dataModelId: this.dataModelId,
        configContent: JSON.stringify(this.searchConditions),
        configType: 'filter',
        pageName: this.pageName,
        pageCode: this.pageCode
      }
    }
    return this.sysUiDisplayService.save(this.searchSettings).toPromise();
  }

  showModal(item) {
    this.detailItem = _.cloneDeep(item);
    this.modalService.create({
      nzTitle: this.translateService.instant('编辑搜索条件'),
      nzContent: this.modalContent,
      nzWidth: '750px',
      nzOnOk: async () => {
        try {
          for (const i in this.detailForm.controls) {
            this.detailForm.controls[i].markAsTouched();
            this.detailForm.controls[i].updateValueAndValidity();
          }
          if (this.detailForm.valid) {
            const saveObj = _.cloneDeep(this.detailItem);
            const index = this.searchConditions.findIndex(data => data.uid === saveObj.uid);
            if (index > -1) {
              this.searchConditions[index] = saveObj;
            } else {
              this.searchConditions.push(saveObj);
            }
            await this.saveConfig();
            this.notification.success(this.translateService.instant('保存成功'), '');
            this.loadData();
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    })
  }

  changeComponentTypeSelection() {
    if (this.detailItem && this.detailItem.componentType === 'select') {
      this.detailItem.selectDataType = this.detailItem.selectDataType ? this.detailItem.selectDataType : 'manual';
    } else {
      this.detailItem.selectDataType = null;
    }

    if (this.detailItem && ['Date', 'Number', 'Datetime'].indexOf(this.modelFieldMap[this.detailItem.modelFieldId].fieldDataType) > -1 &&
      'select' !== this.detailItem.componentType) {
      this.detailForm.get('logicExpress').setValidators(Validators.required);
    } else {
      this.detailItem.logicExpress = null;
      this.detailForm.get('logicExpress').setValidators(null);
    }
  }
  checkSelectDataType() {
    if (this.detailItem && this.detailItem.selectDataType === 'api') {
      this.detailForm.get('selectLabel').setValidators(Validators.required);
      this.detailForm.get('selectValue').setValidators(Validators.required);
    } else {
      this.detailForm.get('selectLabel').setValidators(null);
      this.detailForm.get('selectValue').setValidators(null);
    }
  }

  stringEqual(a: string, b: string) {
    if (a && b) {
      return a.toLowerCase() === b.toLowerCase();
    } else {
      return a === b
    }
  }

  isInTypes(types: string[], targetStr: string) {
    let result = false;
    if (types && targetStr) {
      for (let i = 0; i < types.length; i++) {
        if (types[i].toLowerCase() === targetStr.toLowerCase()) {
          result = true;
          break;
        }
      }
    }
    return result;
  }

}
